import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from './app.reducer';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {startLoading} from './shared/store/ui/ui.actions';
import * as fromCore from './core/store/actions/core.actions';
import {SessionService} from './core/services/session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy{

  loading = false;
  private _unsubscribeAll: Subject<any>;
  constructor(private store: Store<AppState>, private sessionService: SessionService) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.sessionService.getToken().then(token => {
      if (token) {
        this.store.dispatch(fromCore.getUser());
      }
    });

    this.store.select('ui').pipe(takeUntil(this._unsubscribeAll)).subscribe(ui => {
      this.loading = ui.isLoading;
    });
  }
  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
  startLoading(): void {
    this.store.dispatch( startLoading());
  }
}
